
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue-management/tableup-legacy-redirect",
      function () {
        return require("private-next-pages/venue-management/tableup-legacy-redirect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue-management/tableup-legacy-redirect"])
      });
    }
  